// extracted by mini-css-extract-plugin
export default {"slotAppShell":"PlasmicAppShell_slotAppShell__j1dFg","slotAppShelllayoutType__default":"PlasmicAppShell_slotAppShelllayoutType__default__y+6xC"};